import { mode } from '@chakra-ui/theme-tools';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css'; 
import '@fontsource/inter/400-italic.css';
import '@fontsource/inter/500-italic.css';
import '@fontsource/inter/600-italic.css';
import '@fontsource/inter/700-italic.css';
import '@fontsource/inter/900-italic.css';

const inputs = (props) => ({
  transition: '0.3s all !important',
  borderRadius: '16px !important',
  border: 'unset !important',
  p: '20px 12px !important',
  h: '56px !important',
  fontSize: '16px !important',
  fontWeight: '400 !important',
  bg: mode('white !important', '#0E1633 !important')(props),
  color: mode('#0E1633', 'white')(props),
  _hover: {
    boxShadow: 'unset !important',
  },
  _focus:{
    boxShadow: 'unset !important',
    borderColor: 'unset !important'
  },
  _placeholder: {
    color: mode('#7787B0', '#9FABCB')(props)
  }
});

const gender = {
  borderRadius: '30px', 
  w: '100%', 
  maxW: '41px',
  h: '41px', 
  textAlign: 'center',
  'p': { 
    fontSize: '16px',
    fontWeight: '600',
    color: 'white',
    pt: '11px'
  }
};

const tag = {
  p: '3px 0',
  borderRadius: '20px',
  textAlign: 'center',
  mt: '6px',
  maxW: '110px'
};

export const globalStyles = {
  colors: {
    blue: {
      20: '#F4F6FF',
      25: '#AEC6FF',
      50: '#D8E2FF',
    },
    red: {
      0: '#FFE1DF',
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode('#E0EAFF', '#050A19')(props),
        fontFamily: '\'Inter\', sans-serif',
        overflowX: 'hidden',
        //fontFeatureSettings: "'liga' off, 'clig' off"
      },
      html: {
        fontFamily: '\'Inter\', sans-serif'
      },
      '#root': {
        overflow: 'hidden'
      },
      '*': {
        outline: 'none !important',
        userSelect: 'none !important',
        '-webkit-user-select': 'none !important',
        '-ms-user-select': 'none !important',
        '-moz-user-select': 'none !important',
        '-webkit-tap-highlight-color': 'transparent !important',
        'font-feature-settings': "'liga' off, 'clig' off"
      },
      select: {
        ...inputs(props),
        h: 'unset !important',
        p: '16px 18px !important'
      },
      'input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
          opacity: 0
      },
      'input[type="date"]::-webkit-calendar-picker-indicator': {
          opacity: 0
      },
      '.edit-mode .chakra-select__icon-wrapper': {
          opacity: 0
      },
      'select.select-md': {
        ...inputs(props),
        h: 'unset !important',
        p: '8px 16px !important'
      },
      b: {
        fontWeight: '500'
      },
      input: {
        ...inputs(props),
      },
      textarea: {
        ...inputs(props),
      },
      'input.input-invalid': { boxShadow: '0px 0px 0px 1px red' },
      'textarea.input-invalid': { boxShadow: '0px 0px 0px 1px red' },
      'select.input-invalid': { borderColor: 'red !important' },
      '.input-invalid': { 
        'input': { borderColor: 'red !important' },
      },
      'label.input-invalid': { color: 'red !important' },
      'button.freeze': { pointerEvents: 'none' },
      '.freeze': { pointerEvents: 'none', opacity: '0.3' },
      '.freeze-iframe': { pointerEvents: 'none', opacity: '0.7' },
      '.input-error': {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'absolute',
        backgroundColor: mode('white','#0e1633')(props),
        pointerEvents: 'none',
        borderRadius: '5px',
        mx: '14px !important',
        px: '4px !important',
        my: '15px !important',
        transformOrigin: 'left top',
        color: 'red !important',
        fontWeight: '400',
        fontSize: '14px',
        transform: 'scale(0.85) translateY(35px)',
        lineHeight: 'normal !important'
      },
      '.hidden': { display: 'none !important' },
      '.chakra-modal__content-container': {
        bg: mode('rgba(255, 255, 255, 0.30)','rgba(0, 0, 0, 0.30)')(props),
        backdropFilter: 'blur(12px)',
        px: '15px',
        '.chakra-modal__content': {
          p: '33px',
          pb: '40px',
          borderRadius: '16px !important',
          border: mode('unset', '1px solid #262D47')(props),
          background: mode('#CBE7FF', '#0F1426')(props),
        },
        '.chakra-modal__header': {
          fontSize: '32px !important',
          fontWeight: '700 !important',
          color: mode('#1B1B1F !important', 'white !important')(props),
          pb: '0px !important'
        },
        '.modal_code': {
          background: mode('#E0EAFF', '#0F1426')(props),
        },
        '.modal__simple': {
          padding: '15px 15px 24px 15px',
          '*': {
            transition: '0.3s all'
          },
          '.chakra-modal__header': {
            p: '0px',
            pb: '0px',
          },
          '.chakra-modal__body': {
            padding: '0px !important',
          },
          '.chakra-modal__close-btn': {
            bordeWidth: '0px',
            w: '32px',
            h: '32px',
            m: '-1px -5px 0px 0',
            borderRadius: '10px',
            bg: mode('unset', '#0E1633')(props),
            outline: 'none !important',
            boxShadow: 'none !important',
            'svg': {
              w: '14px',
              h: '14px',
              color: mode('black', 'white')(props),
            },
            _hover: {
              bg: mode('unset', 'transparent')(props),
            },
            _active: {
              bg: mode('unset', 'transparent')(props),
            },
            _focus: {
              outline: 'none !important',
              boxShadow: 'none !important'
            }
          },
        },
      },
      '.PhoneInputCountry' : {
        position: 'absolute !important',
        p: '21px 0 0px 20px !important',
        zIndex: '9 !important'
      }, 
      '.PhoneInputInput': { 
        p: '15px 20px 15px 70px !important',
        bg: 'transparent',
        _focusVisible: {
          outline: 'none !important'
        } 
      },
      '.PhoneInputCountryIcon': { fontSize: '14px', boxShadow: 'unset' },
      '.PhoneInputCountrySelectArrow': { 
        margin: '-4px 0 0 8px', 
        fontSize: '23px', 
        color: mode('#1f2733 !important', 'white !important')(props),
        opacity: '1'
      },
      '.PhoneInput': { mb: '24px' },
      '.PhoneInputCountryIcon--border': { boxShadow: 'unset !important' },
      '.vi__container': {
        w: 'unset',
        m: '22px auto 27px auto',
        input: {
          border: 'unset !important',
          _hover: {
            boxShadow: 'unset !important',
          },
          _focus:{
            boxShadow: 'unset !important',
            borderColor: 'unset !important'
          }
        },
        '.vi__character': {
            borderRadius: '50px',
            maxWidth: '50px',
            fontSize: '24px',
            minWidth: '50px',
            borderColor: 'gray.50',
            color: 'gray.800'
        },
        '.character--inactive': { background: 'transparent !important', color: 'gray.800' },
        '.vi__character--filled': { 
            borderColor: 'blue.200', 
            color: 'gray.800', 
            boxShadow: mode('0 0 0 0.5px #CBE7FF !important', '0 0 0 0.5px #050A19 !important')(props)
        },
        '.character--selected': {
            outline: 'unset !important', 
            color: 'gray.800', 
            borderColor: 'blue.200', 
            boxShadow: mode('0 0 0 0.5px #CBE7FF !important', '0 0 0 0.5px #050A19 !important')(props)
        },
      },
      '.code-container-mobile .vi__character': {
        minW: '42px !important',
        maxW: '42px !important',
      },
      '.code-container': {
        w: 'max-content',
        m: '18px auto 18px auto',
        input: {
          border: 'unset !important',
          pointerEvents: 'none',
          opacity: '0',
          _hover: {
            boxShadow: 'unset !important',
          },
          _focus:{
            boxShadow: 'unset !important',
            borderColor: 'unset !important'
          }
        },
        '.vi__character': {
            borderRadius: '16px',
            minW: '67px',
            maxW: '67px',
            maxH: '56px',
            minH: '56px',
            fontSize: '16px',
            fontWeight: '500',
            borderColor: '#050A19',
            borderWidth: '0px',
            color: mode('#050A19', 'white')(props),
            padding: '3px 12px;',
            boxShadow: 'unset',
            bg: mode('white !important', '#050A19 !important')(props)
        },
        '.character--inactive': { color: 'white' },
        '.vi__character--filled': { 
            borderColor: mode('white !important', '#050A19 !important')(props),
            color: mode('#050A19', 'white')(props),
            boxShadow: mode('unset', '0 0 0 1px #050A19 !important')(props)},
        '.character--selected': { outline: 'unset !important', color: 'white', borderColor: '#050A19' },
        '.input-freeze-code' : {bg: 'gray.100', boxShadow: '0 0 0 1px #D8E2FF !important', pointerEvents: 'none'}
      },
      '.input-invalid-code': {
        '.vi__character': {
          bg: '#FFF8F7',
          borderColor: 'red.200',
          boxShadow: '0 0 0 0.5px red !important' 
        }
      },
      '.circle-object': {
        w: '40px',
        h: '40px',
        borderRadius: '20px',
        color: '#1B1B1F !important',
        fontWeight: '600 !important',
        p: '8px 15px'
      },
      '.boxObject-active': { bg: 'blue.200', color: 'white !important'},
      '.boxObject-inactive': { boxShadow: '0 0 0 1px #C5C6D0' },
      '[role="menuitem"]': {
        _focus: {
                bg: 'transparent !important',
            },
            _hover: {
                bg: 'transparent !important',
            },
            _active: {
                bg: 'transparent !important',
            }
      },
      '.chakra-radio': {
        pb: '10px',
        '.chakra-radio__control': {
          w: '22px',
          h: '22px',
          borderColor: '#9FABCB',
          borderWidth: '0.11em',
          mr: '5px',
          _focus: {
            boxShadow: 'unset !important'
          },
          '&[data-checked]': {
            bg: '#0b9bff !important',
            borderColor: '#0b9bff !important'
          },
        },
      },
      '.settings-tabs': {
        a: {
          fontSize: '16px',
          fontWeight: '600',
          color: mode('gray.800', 'white')(props),
          me: '24px',
          mb: '-1px',
          pb: '5px'
        },
        '.settings-tab-active': {
           color: mode('blue.200', '#0497FD')(props),
           borderColor: mode('blue.200', '#0497FD')(props),
           borderBottom: '1px'
        }
      },
      '.membership-tabs': {
        borderColor: mode('#CBE7FF !important', 'rgba(255, 255, 255, 0.10) !important')(props),
        a: {
          fontSize: '16px',
          fontWeight: '500',
          color: mode('#0E1633', 'white')(props),
          me: '24px',
          mb: '-1px',
          pb: '8px',
          px: '8px'
        },
        '.membership-tab-active': {
           color: mode('#099BFF', 'white')(props),
           borderColor: mode('rgba(9, 155, 255, 0.10)', '#2ABDFD !important')(props),
           borderBottom: '1px'
        }
      },
      '.notify-success': {
        bg: 'green.50'
      }, 
      '.notify-error': {
        bg: 'red.0'
      },
      '.chakra-checkbox': {
        transition: '0.0s all !important',
        '*': { transition: '0.0s all !important'}
      },
      'button[aria-haspopup="menu"]': {
        transition: '0.2s all !important',
        '*': { transition: '0.2s all !important'}
      },
      '.chakra-checkbox__control': {
        w: '20px !important',
        h: '20px !important',
        borderRadius: '5px !important',
        borderColor: '#9FABCB !important',
        borderWidth: '0.099em !important',
        _hover: {
          outline: 'none !important',
          boxShadow: 'none !important'
        },
        _active: {
          outline: 'none !important',
          boxShadow: 'none !important',
        },
        _focus: {
          outline: 'none !important',
          boxShadow: 'none !important'
        }
      },
      '.chakra-checkbox__label': {
        pl: '4px'
      },
      '.chakra-checkbox__control[data-checked]':{
        bg: 'linear-gradient(0deg, #0497FD, #2ABDFD) !important',
        border: 'unset'
      },
      '.chakra-switch': {
        transform: 'scale(1.2)',
        '.chakra-switch__track': {
          bg: '#333F6D !important',
          _focus: {
            boxShadow: 'unset !important'
          },
          '> span': {
            bg: '#0A1027 !important'
          },
          '&[data-checked]': {
            bg: '#099BFF !important',
          }
        },
      },
      '.selected-ball': {
        bg: 'linear-gradient(152deg, #34A853 0.67%, #77C01B 39.93%, #34A853 89.58%), #1870EC !important',
        boxShadow: '0px 2px 4px 0px rgba(255, 255, 255, 0.10) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.10) !important',
        fontWeight: '700 !important',
        color: 'white !important',
        position: 'relative !important',
        fontSize: '20px !important',
        pt: '8px !important',
        _after:{
          content: '""',
          position: 'absolute',
          bg: 'rgba(255, 255, 255, 0.79)',
          filter: 'blur(4.300000190734863px)',
          w: '7px',
          h: '19px',
          transform: 'rotate(49.011deg)',
          left: '9px',
          top: '3px'
        }
      },
      'img.current-avatar': {
        boxShadow: '0 0 0 0.1em #1870EC',
        borderRadius: '30px'
      },
      '.active-svg': {
        'path': {
          fill: 'blue.200'
        }
      },
      '.chakra-menu__menu-button': {
        _hover: {
          outline: 'none !important',
          boxShadow: 'none !important',
          bg: 'transparent !important'
        },
        _active: {
          outline: 'none !important',
          boxShadow: 'none !important',
          bg: 'transparent !important'
        },
      },
      '.page-list':{
        svg: {
            w: '28px',
            h: '28px'
        },
        '.active': {
          '.item-sidebar': {
             bg: mode('blue.50', 'rgba(216, 226, 255, 0.05)')(props),
             borderRadius: '10px'
          }
        }
      },
      '.chakra-breadcrumb': {
          mb: '8px',
          a: {
            color: 'blue.20',
            textDecoration: 'none !important', 
            _focus: {
              boxShadow: 'unset !important'
            },
            div: {
              span: {
                pl: '16px'
              }
            }
          },
          svg: {
            position: 'absolute',
            mt: '-1px',
            path: { fill: 'blue.20', stroke: 'blue.20' }
          },
          '.active': {
            fontWeight: '600',
            color: '#099BFF',
            pointerEvents: 'none',
          },
          span: {
              ml: '5px !important',
              me: '0px'
          }
      },
      '.react-datepicker-wrapper': {
        w: '100%',
        input: {
            w: '100%',
            h: '54px'
        },
        'input[disabled]': {
            opacity: '0.4',
            background: 'transparent',
            pointerEvents: 'none'
        }
      },
      '.tag-blue': {
        ...tag,
        bg: mode('blue.50', '#099BFF')(props),
        color: mode('#1870EC !important', 'white !important')(props),
      }, 
      '.tag-green': {
        ...tag,
        bg: mode('green.50', 'rgba(87, 209, 117, 0.15)')(props), 
        color: mode('#1E7735 !important', '#57D175 !important')(props), 
      }, 
      '.tag-red': {
        ...tag,
        bg: mode('red.75', 'rgba(255, 159, 173, 0.15)')(props), 
        color: mode('#ED1145 !important', '#FF6982 !important')(props), 
      },
      '.tag-orange': {
        ...tag,
        bg: mode('#FFF1C5', 'rgba(255, 185, 27, 0.15)')(props), 
        color: mode('#E26E00 !important', '#FFB91B !important')(props), 
      },
      '.tag-purple': {
        ...tag,
        bg: '#F6EAFD',
        color: '#AF52DE !important'
      },
      '.tag-gray': {
        ...tag,
        bg: '#EFF0FA',
        color: '#50525A !important'
      },
      '.tag-transparent': {
        ...tag,
        bg: mode('gray.50', '#0D234D')(props), 
        color: mode('black !important', 'white !important')(props), 
      },
      '.tag-secondary': {
        ...tag,
        whiteSpace: 'nowrap',
        w: 'fit-content',
        p: '3px 12px',
        bg: mode('#0D234D', '#0D234D')(props), 
        color: mode('white !important', 'white !important')(props), 
        mr: '8px',
        display: 'inline-flex',
        maxWidth: '100%'
      },
      '.cursor-tr': {
        _hover: {
          cursor: 'pointer',
          bg: mode('#FAF9FF', '#10337F !important')(props),
        }
      },
      '.full-width-chart': {
        w: '100% !important',
        '.apx-legend-position-top': {
            'span.apexcharts-legend-text': {
              pl: '20px !important'
            }
        }
      },
      '.gender': {
        '&-male': { ...gender, bg: '#508DFF'},
        '&-female': { ...gender, bg: '#FF2D55'},
        '&-other': { ...gender, bg: '#FF9500'},
        '&-none': { ...gender, bg: '#00C7BE'},
      },
      '.filter-date': {
        p: '0 0 16px 0 !important',
        w: '303px !important',
        overflow: 'hidden',
        button: {
          _hover: {
            bg: '#10337F !important'
          }
        },
        '.react-datepicker-wrapper': {
          p: '8px',
          w: '100%'
        },
        '.filter-date-placeholder': {
          left: '24px',
          top: '17px',
          color: '#9FABCB'
        },
        input: {
          w: '100%',
          h: '40px !important',
          p: '6px 16px !important',
          bg: 'rgba(5, 11, 33, 0.54)',
          mb: '4px',
          borderRadius: '10px !important',
          borderColor: 'unset !important',
          borderWidth: '0 !important',
          color: 'white',
          _hover: {
            outline: 'none !important',
            boxShadow: 'none !important'
          },
          _active: {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          _focus: {
            outline: 'none !important',
            boxShadow: 'none !important'
          },
          _placeholder: {
            color: 'white'
          }
        },
        '.apexcharts-text tspan': {
          fill: '#9FABCB !important'
        },
      },
      '.abstract-grad': {
        width: '180px',
        height: '0',
        zIndex: '-1',
        borderRadius: '200px',
        position: 'absolute',
        boxShadow: '30px 0px 150px 100px rgba(9,155,255,.2)'
      },
      '.abstract-lines': {
        position: 'absolute',
        top: '-100px',
        left: '10%',
        zIndex: '-1'
      },
      '.slick-list': {
        overflow: 'visible !important'
      },
      'ul.slick-dots li button:before': {
        color: mode('rgba(0, 0, 0, 0.10)', 'rgba(255, 255, 255, 0.10)')(props),
        opacity: 1,
        fontSize: '10px',
        top: '0px'
      },
      'ul.slick-dots li.slick-active button:before': {
        color: '#099BFF',
      },
      'ul.slick-dots li': {
        m: '0 -3px'  
      },
      '.chakra-breadcrumb svg path': {
        fill: 'transparent',
        stroke: '#8794C2'
      },
      '.chakra-breadcrumb span': {
        ml: '24px !important'
      },
      '.chakra-breadcrumb svg': {
          position: 'absolute',
          mt: '-8px',
          ml: '-20px'
      },
      '.banner-slider': {
        '.slick-dots': {
          bottom: 'unset',
          position: 'absolute',
          top: '73px',
          textAlign: 'right',
          right: '16px', 
          'li button:before': {
            top: '0px'
          }
        },
        '&.banner-slider-mobile': {
          '.slick-dots': {
            top: '26px',
          }
        }
      },
      '.giveaways-gallery': {
        '.slick-slide': {
          transition: '0.3s all',
          opacity: '0 !important'
        },
        '.slick-slide.slick-active.slick-current':{
          opacity: '1 !important'
        },
        '.slick-dots': {
          bottom: '15px',
          'li': {
            w: '8px',
            h: '8px',
            m: '0px'
          }  
        }
      },
      '.giveaways-gallery-mini': {
        mt: '10px',
        h: '80px',
        '.slick-slide': {
          transition: '0.3s all',
          opacity: '1 !important'
        },
        '.slick-slide.slick-active.slick-current':{
          opacity: '1 !important'
        },
        '.slick-dots': {
          bottom: '15px',
          'li': {
            w: '8px',
            h: '8px',
            m: '0px'
          }  
        }
      },
      '.giveaways-prizes': {
        '.slick-slide': {
          transition: '0.3s all',
          opacity: '0 !important'
        },
        '.slick-slide.slick-active.slick-current':{
          opacity: '1 !important'
        },
        '.slick-dots': {
          bottom: '-15px',
          'li': {
            w: '8px',
            h: '8px',
            m: '0px'
          }  
        },
        '.slick-track': {
            display: 'flex',
            alignItems: 'center'
        }
      },
      '.account-tabs': {
        display: 'block',
        '*': {
          transition: '0.3s all'
        },
        'a': {
          display: 'flex',
          height: '48px',
          paddingLeft: '12px',
          alignItems: 'center',
          gap: '16px',
          mb: '2px',
          alignSelf: 'stretch',
          borderRadius: '16px',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '21px',
          letterSpacing: '-0.32px',
          _hover: {
            bg: mode('rgba(9, 155, 255, 0.10)', '#0D234D')(props),
          },
          '&.tab-active': {
            bg: mode('rgba(9, 155, 255, 0.10)', '#0D234D')(props),
            color: '#099BFF'
          }
        }
      },
      '.menu-header + div': {
        minW: '100% !important',
        px: '15px !important',
      },
      '.membership-terms-conditions': {
        'em': {
          color: 'inherit !important',
          background: 'transparent !important'
        },
        'span': {
          color: 'inherit !important',
          background: 'transparent !important'
        }
      },
      '.slick-slider-withdraw-account ul.slick-dots li button:before': {
        top: '0px'
      },
      '.daily-wheel-svg-white-theme': {
        fill: '#1FB4FD',
        'path': {
          fill: '#1FB4FD'
        }
      },
      '.slider-build-different:before': {
          content: '""',
          position: 'absolute',
          width: '100px',
          height: '100%',
          background: 
            mode( 
              'linear-gradient(270deg, rgba(224, 234, 255, 0.00) 0%, #E0EAFF 100%)',
              'linear-gradient(270deg, rgba(0, 7, 28, 0.00) 0%, #00071C 100%)',
            )(props),
          left: '0',
          top: '0',
          zIndex: '9'
      },
      '.slider-build-different:after': {
          content: '""',
          position: 'absolute',
          width: '100px',
          height: '100%',
          background: 
            mode( 
              'linear-gradient(90deg, rgba(224, 234, 255, 0.00) 0%, #E0EAFF 100%)',
              'linear-gradient(90deg, rgba(0, 7, 28, 0.00) 0%, #00071C 100%)',
            )(props),
          right: '0',
          top: '0',
          zIndex: '9'
      },
      '.html-component': {
        'ol': { 
          ml: '40px',
          'li[data-list="bullet"]': {
            listStyle: 'initial'
          }
        },
        '.ql-align-center': { textAlign: 'center' },
        '.ql-align-right': { textAlign: 'right' },
        'h1': { fontSize: '2em' },
        'h2': { fontSize: '1.5em' }, 
        'h3': { fontSize: '1.17em' }
      },
      '.ratio-checkbox .chakra-checkbox__control': {
        borderRadius: '24px !important'
      },
      '.maplibregl-ctrl-attrib': {
        background: 'rgba(0, 0, 0, 0.1) !important',
        color: 'rgba(255, 255, 255, 0.4) !important',
        fontSize: '8px !important',
        borderRadius: '8px !important',
        boxShadow: 'none !important'
      },
      '.maplibregl-ctrl-attrib a': {
        color: 'rgba(255, 255, 255, 0.4) !important',
        textDecoration: 'none !important'
      },
      '.mapboxgl-ctrl.mapboxgl-ctrl-attrib': { opacity: '0.3', mr: '90px'},
      '.mapboxgl-ctrl-attrib-inner a': { fontSize: '11px' },
      '.mapbox-improve-map': { display: 'none' },
      'select#filter-select': {
        padding: '8px 14px !important',
        color: mode('#0E1633 !important', '#9FABCB !important')(props),
      },
      '.modal__simple_update-avatar': {
        overflow: 'hidden',
        '*': {
          transition: '0s all !important'
        }
      },
      '.chakra-modal__content.modal__simple.modal__simple_full-screen': {
        h: '100%',
        padding: '0px 15px !important',
        position: 'absolute !important',
        margin: '0 !important',
        borderRadius: '0px !important',
        bg: mode('#E0EAFF !important', '#050A19 !important')(props),
        borderWidth: '0px !important',
        maxW: '100% !important',
        overflowX: 'hidden !important',
        overflowY: 'scroll !important',
        ' > div': {
          maxWidth: '1128px',
          w: '100%',
          h: '100%',
          overflow: 'visible',
          position: 'relative',
          maxHeight: '100%', 
          m: '0px auto 0 auto'
        },
        '.modal_full-screen-partners-doubles > div:first-child': {
          overflow: 'hidden'
        },
        '.modal_full-screen-partners-doubles > div:last-child': {
          overflow: 'hidden'
        }
      },
      '.red-text-underline': {
        background:'linear-gradient(180deg, #FD2A2A 0%, #AF0000 100%)',
        backgroundClip: 'text',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        position: 'relative',
        ':before': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          h: '1px',
          background: '#AF0000'
        }
      },
      '.membership-table td, .membership-table tr': {
          padding: 0
      },
      '.blue-text': {
        background:'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)',
        backgroundClip: 'text',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent'
      }
    })
  }
};
